import { render, staticRenderFns } from "./Recebimentos.vue?vue&type=template&id=24dbc565"
import script from "./Recebimentos.vue?vue&type=script&lang=js"
export * from "./Recebimentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports